var map = {
	"./app.yml": "./settings/app.yml",
	"./constants.yml": "./settings/constants.yml",
	"./content.env": "./settings/content.env",
	"./content.yml": "./settings/content.yml",
	"./errors.yml": "./settings/errors.yml",
	"./gtm-settings.json": "./settings/gtm-settings.json",
	"./menu.yml": "./settings/menu.yml",
	"./portal.env": "./settings/portal.env",
	"./portal.json": "./settings/portal.json",
	"./survey.yml": "./settings/survey.yml"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./settings sync recursive (\\.json|\\.ya?ml|\\.env)";